<template>
    <div class="cd-timeline-content cd-timeline--log-card">
        <div class="cd-timeline-content-text">
            <div class="cd-timeline-content--staff">
                <template v-for="(part, index) in contentParts" :key="index">
                    <PersonLight
                        v-if="part.type === 'person-list'"
                        :person="part.data"
                        :class="part.classes"
                    />
                    <ObjectList
                        v-else-if="part.type === 'object-list'"
                        :list="part.data"
                        :class="part.classes"
                    />
                    <span v-else :class="part.classes" v-html="part.content" />
                </template>
            </div>
            <span class="nowrap gray-60 fs-2">
                {{ $filters.dateFormatter(oneLog.timestamp, 'NORMAL_DATE_TIME', true) }}
            </span>
        </div>
    </div>
</template>

<script>
import IconMixin from '../../mixins/IconMixin';
import TimelineCardMixin from './TimelineCardMixin';
import TimelineWordingMixin from './TimelineWordingMixin';
import PersonLight from 'vcomponents/utilities/PersonLight.vue';
import ObjectList from 'vcomponents/utilities/ObjectList.vue';
import TIMELINE_WORDINGS from './wording.js';

export default {
    components: {
        PersonLight,
        ObjectList,
    },
    mixins: [IconMixin, TimelineCardMixin, TimelineWordingMixin],
    computed: {
        contentParts() {
            const params = {};
            const componentParams = {};

            Object.keys(this.oneLog.params).forEach((key) => {
                if (
                    typeof this.oneLog.params[key] === 'object' &&
                    this.oneLog.params[key]['type'] === 'component'
                ) {
                    componentParams[key] = this.oneLog.params[key];
                    params[key] = `{${key}}`; // Marqueur simple
                } else {
                    params[key] = `<span class='bold mr-1'>${this.oneLog.params[key]}</span>`;
                }
            });

            const wordingKey =
                this.oneLog.objecttype !== this.linkedtype &&
                TIMELINE_WORDINGS[this.oneLog.action + '.linked']
                    ? this.oneLog.action + '.linked'
                    : this.oneLog.action;

            const content = this.getWording(wordingKey, params);

            // Keys triées par ordre d'apparition
            const orderedKeys = Object.keys(componentParams)
                .map((key) => ({ key, idx: content.indexOf(`{${key}}`) }))
                .filter(({ idx }) => idx !== -1)
                .sort((a, b) => a.idx - b.idx)
                .map(({ key }) => key);

            const parts = [];
            let remainingContent = content;

            orderedKeys.forEach((key) => {
                const marker = `{${key}}`;
                if (remainingContent.includes(marker)) {
                    const [before, after] = remainingContent.split(marker);

                    if (before) {
                        parts.push({
                            type: 'text',
                            content: before,
                            classes: '',
                        });
                    }

                    const paramData = componentParams[key];
                    let classes = 'mr-1';

                    if (paramData.name === 'person-list') {
                        classes += ' cd-timeline-content--block';
                        parts.push({
                            type: 'person-list',
                            data: paramData.params.list[0],
                            classes: classes,
                        });
                    } else {
                        classes += ' dinlineb';
                        parts.push({
                            type: 'object-list',
                            data: paramData.params.list,
                            classes: classes,
                        });
                    }

                    remainingContent = after || '';
                }
            });

            if (remainingContent) {
                parts.push({
                    type: 'text',
                    content: remainingContent,
                    classes: '',
                });
            }

            return parts;
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.cd-timeline--log-card {
    .cd-timeline-content--staff {
        display: inline-block;

        .cd-timeline-content--block {
            display: inline-block;
            vertical-align: middle;
        }

        .person-light {
            display: inline-block;
        }
        .person-light-avatar__container {
            .compass-user__name {
                font-weight: 600;
                cursor: auto;
                font-size: 14px;
            }

            &:hover {
                .compass-user__name {
                    color: $gray-80;
                }
            }
        }
    }
}
</style>
